export default __webpack_public_path__ + "static/media/login_bg.76c8e844.jpg";